import React, { useEffect } from 'react';
import classes from './ClientManager.module.css';
import { keyDevsLogo, EmptyProfileImage } from '../../constant/imagePath';
import { MdWifiCalling3 } from 'react-icons/md';
import { IoIosMail, IoLogoWhatsapp } from 'react-icons/io';
import { SlUserFollow, SlUserFollowing } from 'react-icons/sl';
import Tooltip from '../Tooltip';
import { useState } from 'react';
import EmailAgentModal from '../../modals/EmailAgentModal';
import { imageUrl } from '../../config/apiUrl';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useFollowUnFollowCompanyOrAgentMutation } from '../../store/apiSlice/apiSlice';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import { updateUser } from '../../store/auth/authSlice';
import Button from '../Button/Button';
import { toast } from 'react-toastify';

const ClientManagerCard = ({
  data = {
    name: 'AgentCard',
    designation: 'Client Manager',
    photo: EmptyProfileImage,
    logo: keyDevsLogo,
    languages: ['English']
  },

  dataType
}) => {
  const dispatch = useDispatch();
  const { isLogin, user } = useSelector((state) => state.authReducer);
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { t } = useTranslation('webCommon');
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [onFollow, { isLoading }] = useFollowUnFollowCompanyOrAgentMutation();
  const [isScrolled, setIsScrolled] = useState(false);

  const renderData = React.useMemo(
    () => (data?.assignedAgent ? data?.assignedAgent : data?.company ? data?.company : null),
    [data]
  );
  const isFollowed =
    renderData?.role == 'company'
      ? user?.companyFollowing?.includes(renderData?._id)
      : user?.agentFollowing?.includes(renderData?._id);

  const handleAction = () => {
    const isAllowedActions = restrictOnlyUserActions(user?.role);
    if (!isLogin) {
      navigate('/login');
    } else if (isAllowedActions) {
      return true;
    }
  };

  async function handleFollow() {
    if (!handleAction()) return;
    const res = await onFollow(renderData?._id);
    if (res?.data) {
      dispatch(updateUser(res?.data?.data));
      toast.success(
        `${
          renderData?.role == 'company'
            ? `${t('propertyDetailAgentCard.company')}`
            : `${t('propertyDetailAgentCard.agent')}`
        } 
        ${
          isFollowed
            ? `${t('propertyDetailAgentCard.unFollowed')}`
            : `${t('propertyDetailAgentCard.followed')}`
        }`
      );
    }
  }

  const handleScroll = () => {
    const distFromTop = document.querySelector('#socialIconsId').getBoundingClientRect().bottom;
    setIsScrolled((prev) => distFromTop < (prev ? 160 : 205)); // Change this value as needed
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div id="socialIconsId" className={classes.main}>
      <div className={`${classes?.agentIntroContainer}`}>
        <div
          className={classes?.profileImageContainer}
          onClick={() =>
            navigate(`/${renderData?.role == 'agent' ? 'agents' : 'company'}/${renderData?.slug}`)
          }>
          <img src={imageUrl(renderData?.photo)} />
        </div>
        <h5>
          {renderData?.agentName?.[selectedLanguage] ?? renderData?.companyName?.[selectedLanguage]}
        </h5>
        {renderData?.role == 'agent' && (
          <div
            className={classes.specialty}
            title={renderData?.agentDesignation?.map((e) => e?.[selectedLanguage])?.join(', ')}>
            {/* <span> */}
            {/* {t('propertyDetailAgentCard.speaks')} */}
            {/* Designations :{' '} */}
            {/* </span> */}
            {/* show 2 designations and +more */}
            {renderData?.agentDesignation
              ?.map((e) => e?.[selectedLanguage])
              ?.slice(0, 2)
              ?.join(', ')}
            {renderData?.agentDesignation?.length > 2 ? (
              <span>, +{renderData?.agentDesignation?.length - 2}</span>
            ) : (
              ''
            )}
          </div>
        )}

        <p className="text-center">
          {renderData?.agentDesignation?.[selectedLanguage] ??
            renderData?.companyType?.[selectedLanguage]}
        </p>
        <Button
          className={classes?.followBtnContainer}
          onClick={() => {
            handleFollow();
          }}
          disabled={isLoading}>
          {isLoading ? (
            ''
          ) : isFollowed ? (
            <SlUserFollowing fill="#00a997" size={16} />
          ) : (
            <SlUserFollow fill="#00a997" size={16} />
          )}
          {isLoading
            ? t('propertyDetailAgentCard.followBtnLoading')
            : isFollowed
            ? t('propertyDetailAgentCard.following')
            : t('propertyDetailAgentCard.follow')}
        </Button>
        {isOpen && (
          <EmailAgentModal
            show={isOpen}
            setShow={setIsOpen}
            data={data}
            title={renderData?.role}
            type={dataType}
            inquiryType={'inquiry'}
          />
        )}

        {renderData?.role == 'agent' && (
          <div
            className={classes.language}
            title={renderData?.language?.map((e) => e?.[selectedLanguage])?.join(', ')}>
            <span>{t('propertyDetailAgentCard.speaks')}: </span>
            {/* {renderData?.language?.length > 2
              ? `${renderData?.language
                  ?.map((e) => e?.[selectedLanguage])
                  ?.slice(0, 2)
                  ?.join(', ')}...`
              : renderData?.language?.map((e) => e?.[selectedLanguage])?.join(', ')} */}

            {/* show 2 languages, +more */}
            {renderData?.language
              ?.map((e) => e?.[selectedLanguage])
              ?.slice(0, 2)
              ?.join(', ')}
            {renderData?.language?.length > 2 ? (
              <span>, +{renderData?.language?.length - 2}</span>
            ) : (
              ''
            )}
          </div>
        )}

        {renderData?.role == 'agent' && (
          <div className={classes.midContent}>
            <div
              className={classes.logo}
              onClick={() => navigate(`/company/${renderData?.company?.slug}`)}>
              <img src={imageUrl(renderData?.company?.photo)} alt="" />
            </div>
            {/* <p className={classes.link}>{t('propertyDetailAgentCard.link')}</p> */}
            <div className={classes.companyInfo}>
              <p className={classes.companyName}>
                {renderData?.company?.companyName?.[selectedLanguage]}
              </p>
              <p className={classes.companyType}>
                {renderData?.company?.companyType?.[selectedLanguage]}
              </p>
            </div>
          </div>
        )}

        <div
          className={[classes.socialIconsWrap1, isScrolled && classes.socialIcons1Fixed].join(' ')}>
          <a href={`tel:${renderData?.phoneNumber}`} className={classes.socialIcons1}>
            <Tooltip text={t('propertyDetailAgentCard.tooltips.call')}>
              <MdWifiCalling3 fill="#00A997" size={30} />
            </Tooltip>
          </a>
          <div
            className={[classes.socialIcons1, classes.midIcon].join(' ')}
            onClick={() => setIsOpen(true)}>
            <Tooltip text={t('propertyDetailAgentCard.tooltips.email')}>
              <IoIosMail fill="#00A997" size={30} />
            </Tooltip>
          </div>
          <a
            href={`https://wa.me/${renderData?.whatsapp}`}
            target="_blank"
            rel="noreferrer"
            className={classes.socialIcons1}>
            <Tooltip text={t('propertyDetailAgentCard.tooltips.whatsapp')}>
              <IoLogoWhatsapp fill="#00A997" size={30} />
            </Tooltip>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ClientManagerCard;
